export default "__VITE_ASSET__BKvhLQhi__"